import { digestHanwhaAuthRequest } from "./digestAuthRequest"

export const startHanwhaRecording = async(cameraHostname) => {
    try {
        // Call stop recording first
        await stopHanwhaRecording(cameraHostname);
        let responseData = await digestHanwhaAuthRequest(`https://${cameraHostname}/stw-cgi/system.cgi?msubmenu=storageinfo&action=set&Enable=True&NASIP=192.168.137.1&NASUserID=na&DefaultFolder=carex-storage-hanwha&Storage=2&SunapiSeqId=524`);
        console.log("[HANWHA CAMERA UTILITY] Recording started.", responseData)
        return responseData;
    } catch (error) {
        console.error("[HANWHA CAMERA UTILITY] Failed to start recording.", error)
        return null;
    }
}

export const stopHanwhaRecording = async(cameraHostname) => {
    try {
        let responseData = await digestHanwhaAuthRequest(`https://${cameraHostname}/stw-cgi/system.cgi?msubmenu=storageinfo&action=set&Enable=False&NASIP=192.168.137.1&NASUserID=na&DefaultFolder=carex-storage-hanwha&Storage=2&SunapiSeqId=524`);
        console.log("[HANWHA CAMERA UTILITY] Recording stopped.", responseData)
        return responseData;
    }
    catch (error) {
        console.error("[HANWHA CAMERA UTILITY] Failed to stop recording.", error)
        return null;
    }
}

export const getNetworkShareDisk = async(cameraHostname) => {
    // Resposne looks like this :
    // {
    //     "Storage": 2,
    //     "Type": "NAS",
    //     "UsedSpace": "0",
    //     "TotalSpace": "0",
    //     "Enable": false,
    //     "Status": "",
    //     "NASConfig": {
    //         "DefaultFolder": "carex-storage-hanwha",
    //         "NASIP": "192.168.137.1",
    //         "NASUserID": "na",
    //         "NASPassword": "",
    //         "IsPasswordSet": true
    //     }
    // }
    // This url https://carex-hanwha.mshome.net/stw-cgi/system.cgi?msubmenu=storageinfo&action=view&SunapiSeqId=13343
    try {
        let responseData = await digestHanwhaAuthRequest(`https://${cameraHostname}/stw-cgi/system.cgi?msubmenu=storageinfo&action=view&SunapiSeqId=13343`);
        console.log("[HANWHA CAMERA UTILITY] NAS Storage info fetched.", responseData)
        // Go over the Storages object and return the element that has Type NAS
        return responseData?.Storages?.find(storage => storage.Type === "NAS");
    } catch (error) {
        console.error("[HANWHA CAMERA UTILITY] Failed to fetch NAS storage info.", error)
        return null;
    }
}

export const checkForHanwhaCameraConnection = async (cameraHostname) => {
    try {
        let responseData = await digestHanwhaAuthRequest(`https://${cameraHostname}/stw-cgi/system.cgi?msubmenu=deviceinfo&action=view&SunapiSeqId=13343`);
        return responseData;
    } catch (error) {
        console.error("[CAMERA UTILITY] Failed to check camera connection.", error)
        return null;
    }
}

export const startCameraZoom = async (cameraHostname, zoomValue) => {
    try {
        // Url is https://carex-hanwha.mshome.net/stw-cgi/ptzcontrol.cgi?msubmenu=continuous&action=control&Channel=0&NormalizedSpeed=True&Zoom=${zoomValue}&SunapiSeqId=${Date.now()}
        let responseData = await digestHanwhaAuthRequest(`https://${cameraHostname}/stw-cgi/ptzcontrol.cgi?msubmenu=continuous&action=control&Channel=0&NormalizedSpeed=True&Zoom=${zoomValue}&SunapiSeqId=${Date.now()}`);
        return responseData;
    } catch (error) {
        console.error("[CAMERA UTILITY] Failed to check camera connection.", error)
        return null;
    }
}

export const stopCameraZoom = async (cameraHostname) => {
    try {
        let responseData = await digestHanwhaAuthRequest(`https://${cameraHostname}/stw-cgi/ptzcontrol.cgi?msubmenu=stop&action=control&Channel=0&OperationType=All&SunapiSeqId=${Date.now()}`);
        return responseData;
    } catch (error) {
        console.error("[CAMERA UTILITY] Failed to check camera connection.", error)
        return null;
    }
}

export const checkIfCameraConnected = async (camera, setCameras) => {
    try {
        const response = await checkForHanwhaCameraConnection(camera.hostname);
        const isConnected = !!response;
        console.log("[HANWHA CAMERA UTILITY] Camera connection checked.", isConnected, response)
        setCameras(prevCameras => prevCameras.map(cam => cam.hostname === camera.hostname ? {
            ...cam,
            connected: isConnected,
            status: isConnected ? 'Camera is connected' : 'Camera is not connected'
        } : cam));

        if (!isConnected) {
            setCameras(prevCameras => prevCameras.map(cam => cam.hostname === camera.hostname ? {
                ...cam,
                connected: false,
                status: 'Failed to connect to camera. Please check the connection try again.'
            } : cam));        } 
            
    } catch (error) {
        console.error(`Error checking if camera is connected: ${camera.hostname}`, error);
        setCameras(prevCameras => prevCameras.map(cam => cam.hostname === camera.hostname ? {
            ...cam,
            connected: false,
            status: 'Failed to connect to camera. Please check the connection and refresh the page.'
        } : cam));
    }
};